import { Button, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React, { useState } from "react";

import rightArrow from "../../../../../assets/icons/arrow-circle-right.svg";
import leftArrow from "../../../../../assets/icons/arrow-circle-left.svg";

import "../styles.css";

export default function FinancialScoreChart() {
  const [selectedPaginationPoint, setSelectedPaginationPoint] = useState(3);

  const financialScoreOptions = {
    chart: {
      type: "donut",
      height: 250,
    },
    labels: ["Score", "Remaining"],
    colors: ["#EC942C", "#E0DDF7"],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        startAngle: -180,
        endAngle: 180,
        donut: {
          size: "85%",
          labels: {
            show: true,
            name: { show: true },
            value: {
              show: true,
              fontWeight: 700,
              fontSize: "14px",
              color: "#979797",
            },
            total: {
              show: true,
              showAlways: true,
              label: "4.0",
              fontSize: "48px",
              color: "#4D3280",
              formatter: function () {
                return "Crown";
              },
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
    tooltip: {
      enabled: false,
    },
  };

  const financialScoreSeries = [40, 60]; // 90% filled → score 9.0 / 10

  return (
    <Flex vertical style={{ minWidth: 350 }}>
      <Flex vertical gap={15}>
        <Typography.Title level={5} style={{ marginBottom: 0, fontWeight: 400 }}>
          Financial Score
        </Typography.Title>

        <Flex vertical align="center" justify="center" style={{ border: "1px solid #F0F0F0", borderRadius: 8 }}>
          <Chart options={financialScoreOptions} series={financialScoreSeries} type="donut" width={280} height={230} />

          <Flex align="center" justify="space-between" style={{ width: "100%" }}>
            <Button
              onClick={() => setSelectedPaginationPoint((index) => index - 1)}
              style={{ width: 30, border: "none" }}
              disabled={selectedPaginationPoint <= 1}
            >
              <img src={leftArrow} alt="left-arrow" style={{ width: 28 }} />
            </Button>

            <Flex gap={3}>
              {Array.from({ length: 5 }).map((item, index) => (
                <div
                  className={`chart-pagination ${selectedPaginationPoint === index + 1 && "chart-pagination-active"}`}
                  onClick={() => setSelectedPaginationPoint(index + 1)}
                ></div>
              ))}
            </Flex>

            <Button
              onClick={() => setSelectedPaginationPoint((index) => index + 1)}
              style={{ width: 30, border: "none" }}
              disabled={selectedPaginationPoint >= 5}
            >
              <img src={rightArrow} alt="right-arrow" style={{ width: 28, cursor: "pointer" }} />
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
